import PropTypes from 'prop-types'

const TabPanel = (props) => {
  const { name, value, index, children } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${name}`}
      aria-labelledby={`tab-${name}`}
      {...props}
    >
      {children}
    </div>
  )
}

TabPanel.propTypes = {
  name: PropTypes.string,
  value: PropTypes.number,
  index: PropTypes.number,
  children: PropTypes.node,
}

export default TabPanel
